var render, staticRenderFns
import script from "./ClCollapse.ts?vue&type=script&lang=ts&"
export * from "./ClCollapse.ts?vue&type=script&lang=ts&"
import style0 from "./ClCollapse.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports